<template>

  <div>
    <el-dialog title="分销商审核" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="form">
        <el-form-item label="审核状态" :label-width="formLabelWidth">
          <div>
            <el-radio v-model="form.status" :label="1">审核通过</el-radio>
            <el-radio v-model="form.status" :label="0">待审核</el-radio>
          </div>
        </el-form-item>
        <el-form-item label="报单金额" :label-width="formLabelWidth">
          <el-input v-model="form.pay_price" autocomplete="off"></el-input>
        </el-form-item>
       
      </el-form>
      <div slot="footer" class="dialog-footer" >
        <el-button @click="dialogFormVisible">返回</el-button>
        <el-button type="primary" @click="audit" v-if="status!=1">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Notetaking from '@/api/notetaking.js';
export default {
  data() {
    return {
      status: '',
      reject_reason: '',
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false
    };
  },
  props: ['open_edit', 'form'],
  created() {
    this.status=this.form.status;
    this.dialogVisible = this.open_edit;
  },
  methods: {
    /*修改用户*/
    audit() {
      let self = this;
      let params = this.form;
      Notetaking.audit(params, true)
        .then(data => {
          self.$message({
            message: '操作成功',
            type: 'success'
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {});
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/notetaking/order/dialog/Edit.vue